export default __webpack_public_path__ + "static/media/trr-food-pastry-11.a99d2192.png";